import {
  UPDATE_CONTRACT_TERM,
  UPDATE_CONTRACT_TERM_SUCCEEDED,
  UPDATE_CONTRACT_TERM_FAILED

} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const CONTRACT_BASE_URL = `${API_URL}/api/1.0/accounts`;

/** update contract term */
export const updateContract = createAction(UPDATE_CONTRACT_TERM);
const updateContractSucceeded = createAction(UPDATE_CONTRACT_TERM_SUCCEEDED);
const updateContractFailed = createAction(UPDATE_CONTRACT_TERM_FAILED);

function* updateContractTerm(action) {
  const id = action.payload.id;
  const contractTerm = action.payload.contractTerm;
  const endDate = action.payload.endDateStr;



  let url = buildUrl(`${CONTRACT_BASE_URL}/${id}/contract`)
  const updateContractAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: {
        contractTerm,
        endDate

      }

    }).then((response) => response.data);

  };

  try {
    const response = yield call(updateContractAPI);
    yield put(updateContractSucceeded(response));
  } catch (error) {
    yield put(updateContractFailed(error));
  }
}

export default function* contractDuration() {
  yield takeLatest(UPDATE_CONTRACT_TERM, updateContractTerm);
}
